import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import Spacer from './Spacer'

const templates = [
  {
    name: 'Recruiting outreach',
    description:
      'You never know what email headline is going to grab the attention of your top candidates. Get some ideas with Notion AI.',
    image: '/ai/Picture.svg'
  },
  {
    name: 'Meeting summaries',
    description:
      'Meeting follow-ups are always the same: someone writes (or forgets to write) a summary and assigns action items. Let Notion AI take care of it for you.',
    image: '/ai/Picture2.svg'
  },
  {
    name: 'Weekly meal prep',
    description:
      "Tell us what you have in your fridge, the flavors you want to eat, and Notion AI will handle the rest. It'll even preparing a shopping list for you!",
    image: '/ai/Picture3.svg'
  },

  {
    name: 'Video script generator',
    description:
      'Writing scripts for your idea can be hard to get right. Generate your first draft with Notion AI.',
    image: '/ai/Picture4.svg'
  }
]

const Template = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center w-full">
        <div className="">
          <p className="text-[36px] md:text-[45px] font-[700] max-w-[400px] xl:max-w-[500px] leading-[49px] text-[#050505]       ">
            Start with a template. <br className="xl:hidden" /> Build anything.
          </p>
          <div className="flex items-center mt-8 gap-2 leading-[24px] text-[#9d34da] text-[16px] font-[400]">
            <Link className="" href="/templates">
              Explore all templates
            </Link>

            <svg
              width="13"
              height="11"
              viewBox="0 0 13 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mt-[6px]"
            >
              <path
                d="M7.37226 10.5498L6.49726 9.68617L10.0995 6.0839H0.769989V4.8339H10.0995L6.49726 1.24299L7.37226 0.367987L12.4632 5.4589L7.37226 10.5498Z"
                fill="#9D34DA"
              />
            </svg>
          </div>
        </div>
        <div className="flex justify-end md:mt-[200px] items-end mt-6 lg:mt-6">
          <Image
            src={`/ai/template.svg`}
            alt="Hero"
            width={253}
            height={200}
            className="flex w-[177px] h-[140px] lg:w-[253px] lg:h-[200px] justify-end items-end "
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {templates.map((template, i) => (
          <div key={i} className="bg-[#f6f5f4] rounded-[12px] border-2 ">
            <div className="px-[32px] py-[18px]">
              <div className="w-[26px] h-[26x] ">
                <svg
                  width="18"
                  height="21"
                  viewBox="0 0 18 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.1875 9.79736H17.125V20.3599H0.875V0.859863H8.1875V9.79736ZM11.4375 0.859863H9.8125V8.17236H17.125V6.54736L11.4375 0.859863Z"
                    fill="#9D34DA"
                  />
                </svg>
              </div>
              <p className="mt-[14px] text-[#050505] text-[18px] font-bold leading-[24px] font-inter">
                {template.name}
              </p>
              <p className="max-w-[429px] mt-[6px] mb-[20px] leading-[23px] text-[16px] font-[400] font-inter">
                {template.description}
              </p>

              <Link
                href={`/`}
                className="text-[#9D34DA] text-[16px] gap-1 flex items-center font-[400] font-inter hover:underline"
              >
                Try template{' '}
                <svg
                  width="13"
                  height="11"
                  viewBox="0 0 13 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className=""
                >
                  <path
                    d="M7.37226 10.5498L6.49726 9.68617L10.0995 6.0839H0.769989V4.8339H10.0995L6.49726 1.24299L7.37226 0.367987L12.4632 5.4589L7.37226 10.5498Z"
                    fill="#9D34DA"
                  />
                </svg>
              </Link>
            </div>
            <div className="w-full flex justify-end items-end">
              <Image
                src={template.image}
                alt={template.name}
                width={463}
                height={303}
                className="object-cover w-full"
              />
            </div>
          </div>
        ))}
      </div>

      <Spacer />

      <div className="w-full flex flex-col justify-center items-center gap-[24px]">
        <Image
          src={`/ai/Writing.svg`}
          alt="Writing"
          width={218}
          height={183}
          className=""
        />
        <h2 className="font-[700] text-[45px] text-center md:text-start md:text-[53px] leading-[58px]">
          Try HeyForm AI for free
        </h2>{' '}
        <p className="max-w-2xl mx-auto text-lg text-center">
          Sign up now and see how HeyForm AI can transform your workflow, making
          form creation simpler, faster, and smarter.
        </p>
        <button className="text-[#FFFFFF] text-[16px] leading-[23px] font-[600] rounded-[5px] text-center px-[14px] py-[8px] hover:bg-[#121212]/80 bg-[#121212]">
          Get Notion Free
        </button>
      </div>
    </div>
  )
}

export default Template
